export default __webpack_public_path__ + "static/400x400_2026-10-07-73ac541c70763b2145a887cd52316464.jpg";